import React from 'react';
import TouchableElement from '@components/common/touchableElement';
import { View } from 'react-native';
import { getBoxShadowStyle } from '@styles/shadow';
import { scale as initialScale } from '@components/frame';
import Svg from '@styles/icons/svg';
import { ModeSelectorItemProps } from './types';
import { isAndroid, isWeb, searchDisplayModeTitles } from '@helpers';
import i18n from 'i18n-js';

const ModeSelectorItem = ({ onPress, mode, iconUrl, C, style, currentMode, width, height, scale = initialScale, testID }: ModeSelectorItemProps) => {
  const selected = currentMode === mode;

  return (
    <TouchableElement testID={testID} onPress={onPress}>
      {({ boxStyle, hovered, pressed }) => (
        <View
          style={[
            selected && {
              borderRadius: scale(15),
              backgroundColor: C(hovered && !selected ? 'Segmented/Light/Hover Background' : 'Segmented/Light/Selected Background'),
            },
            selected && getBoxShadowStyle({ type: 'Symmetric', C }),
          ]}
        >
          {isWeb ? (
            <div
              title={i18n.t(searchDisplayModeTitles[mode])}
              style={{
                ...boxStyle,
                width: scale(32),
                height: scale(30),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                ...(selected || hovered
                  ? {
                      backgroundColor: C(hovered && !selected ? 'Segmented/Light/Hover Background' : 'Segmented/Light/Selected Background'),
                      borderRadius: scale(15),
                    }
                  : {}),
                ...style,
              }}
            >
              <Svg
                {...{
                  ...(width ? { width: scale(width) } : {}),
                  ...(height ? { height: scale(height) } : {}),
                  icon: iconUrl,
                  color: C(selected ? 'Segmented/Light/Selected Text' : hovered ? 'Segmented/Light/Hover Text' : 'Segmented/Light/Unselected Text'),
                }}
              />
            </div>
          ) : (
            <View
              style={[
                boxStyle,
                {
                  width: scale(32),
                  height: '100%',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: scale(8),
                },
                style,
                (selected || hovered || pressed) && {
                  backgroundColor: C(hovered || pressed ? 'Segmented/Light/Hover Background' : 'Segmented/Light/Selected Background'),
                  borderRadius: scale(15),
                },
                isAndroid &&
                  selected && {
                    boxShadow:
                      C.scheme === 'light'
                        ? '0px 0px 3px 0px rgba(0, 0, 0, 0.20), 0px 0px 20px 0px rgba(0, 0, 0, 0.03)'
                        : '0px 0px 12px 0px rgba(0, 0, 0, 0.30)',
                  },
              ]}
            >
              <Svg
                {...{
                  ...(width ? { width: scale(width) } : {}),
                  ...(height ? { height: scale(height) } : {}),
                  icon: iconUrl,
                  color: C(
                    selected ? 'Segmented/Light/Selected Text' : hovered || pressed ? 'Segmented/Light/Hover Text' : 'Segmented/Light/Unselected Text'
                  ),
                }}
              />
            </View>
          )}
        </View>
      )}
    </TouchableElement>
  );
};

export default ModeSelectorItem;
